import React from "react";
import { Link } from "react-router-dom";

const Start = ({ startGame, players, playerFunction }) => {

  return (
    <div className="start_container">
      <h1>Welcome to the Fresher's Party</h1>
      <div className="player_details">
        <div className="form__group field">
          <input
            type="text"
            className="form__field"
            placeholder="Enter Name"
            name="first"
            id="firstPlayer"
            value={players.first}
            onChange={playerFunction}
          />
          <label htmlFor="first" className="form__label">
            Enter First Name
          </label>
        </div>
        <div className="form__group field">
          <input
            type="text"
            className="form__field"
            placeholder="Enter Name"
            name="second"
            id="secondPlayer"
            value={players.second}
            onChange={playerFunction}
          />
          <label htmlFor="second" className="form__label">
            Enter Second Name
          </label>
        </div>
      </div>
      <Link to={"/gameStart"} className="btn" onClick={startGame}>
        Start Game
      </Link>

      <div className="dev">
        -Created With 💙 by HARSHAL MUKTE
      </div>
    </div>
  );
};

export default Start;
